import React, { ComponentType } from 'react';

/**
 * React.lazy 동적 임포트 실패(배포 후 청크 해시 변경 또는 네트워크 일시 장애) 시
 * 1회 안전하게 페이지를 새로고침하여 최신 스크립트를 불러오도록 보호하는 래퍼 함수입니다.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T } | T>
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem('chunk_retry_refreshed') || 'false'
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem('chunk_retry_refreshed', 'false');
      // default export가 아니더라도 통일성 있게 감싸서 반환
      if ('default' in component) {
        return component as { default: T };
      }
      return { default: component as T };
    } catch (error) {
      console.error('[lazyWithRetry] Dynamic import failed:', error);

      if (!pageHasAlreadyBeenForceRefreshed) {
        // 무한 새로고침 루프를 방지하기 위해 세션 스토리지에 플래그 설정 후 1회 새로고침
        window.sessionStorage.setItem('chunk_retry_refreshed', 'true');
        window.location.reload();
        // 리로드 진행 중 빈 Promise 유지
        return new Promise<{ default: T }>(() => {});
      }

      // 1회 새로고침 후에도 실패한 경우 상위 ErrorBoundary로 에러 전파
      throw error;
    }
  });
}
